export default "__VITE_ASSET__DBlyZN0h__";